import type { CSSProperties, HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  pad?: boolean;
  hover?: boolean;
}

export function Card({ children, pad = true, hover, className, ...props }: CardProps) {
  return (
    <div className={cn("card", pad && "card-pad", hover && "card-hover", className)} {...props}>
      {children}
    </div>
  );
}

export function CardHead({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("card-head", className)}>{children}</div>;
}

export function CardTitle({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={cn("card-title", className)} style={style}>
      {children}
    </div>
  );
}
